export const words = (chunks: readonly string[]) => chunks.flatMap((c) => c.split(/\s+/).filter(Boolean));

export const boundaries = (chunks: readonly string[]) => {
  let at = 0;
  return new Set(chunks.slice(0, -1).map((c) => (at += c.split(/\s+/).filter(Boolean).length) - 1));
};

export function toggleBoundary(chunks: readonly string[], afterWord: number) {
  const ws = words(chunks);
  if (afterWord < 0 || afterWord >= ws.length - 1) return [...chunks];
  const cuts = boundaries(chunks);
  if (cuts.has(afterWord)) cuts.delete(afterWord);
  else cuts.add(afterWord);
  return ws.reduce<string[][]>((acc, w, i) => {
    acc[acc.length - 1].push(w);
    if (cuts.has(i) && i < ws.length - 1) acc.push([]);
    return acc;
  }, [[]]).map((c) => c.join(" "));
}
